import React from 'react';

import AlertModal from 'components/shared/GlobalModalArea/Modal/AlertModal';

import { useUpdateStartDate } from './functions';
import { IUpdateStartDateProps } from './types';

export const UpdateStartDateModal = ({ res, date }: IUpdateStartDateProps) => {
  const { config } = useUpdateStartDate({ res, date });
  const { headerText, bodyText, onAccept, closeButtonText, confirmButtonText } = config;

  return (
    <AlertModal
      res={res}
      headerText={headerText}
      bodyText={bodyText}
      onAccept={onAccept}
      closeButtonText={closeButtonText}
      confirmButtonText={confirmButtonText}
    />
  );
};
